import { cancelOrder, journeyDomainStore, orderDomainStore } from '@vista-digital/occ-domain'

export const resetOrderStore = () => {
    cancelOrder(true)
    orderDomainStore.reset()
    journeyDomainStore.reset()
}
